import { render, staticRenderFns } from "./LegacySummaryCard.vue?vue&type=template&id=6f0154be&scoped=true"
import script from "./LegacySummaryCard.vue?vue&type=script&lang=js"
export * from "./LegacySummaryCard.vue?vue&type=script&lang=js"
import style0 from "./LegacySummaryCard.vue?vue&type=style&index=0&id=6f0154be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0154be",
  null
  
)

export default component.exports